export default __webpack_public_path__ + "static/media/warmup2.5798bd9c.png";